export const fbPixelHandler = (config, event) => {
  try {
    const { action, value } = event.data;

    if ((window as any).fbq && config.fb_pixel_events) {
      if (action === 'bc-add-item') {
        (window as any).fbq('track', 'AddToCart', {
          value: (value?.estimate?.subtotal || 0) / 100,
          content_ids: value?.items?.map(item => item.variant?.id),
          currency: 'USD',
        });
      } else if (action === 'bc-begin-checkout') {
        (window as any).fbq('track', 'InitiateCheckout');
      } else if (action === 'bc-add-address') {
        (window as any).fbq('track', 'AddAddressInfo');
      } else if (action === 'bc-sale') {
        const { payload } = value;
        (window as any).fbq('track', 'Purchase', {
          value: payload.total / 100,
          currency: 'USD',
        });
      }
    }
  } catch (_) {
    console.error('FB Pixel error', _);
  }
};
